





















































































import Vue from 'vue'
import { mapState } from 'vuex'
import eventoService from '../services/evento'
import Swal from 'sweetalert2'

export interface RegistroAsistenciaComponentData {
  emailRules: any[]
  valid: boolean
  visible: boolean
  dni: number | string
  email: string
  nombres: string
  apellidos: string
  dniRules: any[]
  phoneRules: any[]
  nameRules: any[]
  lastnameRules: any[]
  telefono: number | null
  otro: boolean
  auxins: string | null
  programaRules: any[]
  programa: string
  institucion: string
}

export default Vue.extend({
  props: ['value', 'id_evento', 'url_evento'],
  data(): RegistroAsistenciaComponentData {
    return {
      emailRules: [
        (v: any) => !!v || 'E-mail es requerido',
        (v: any) =>
          /^\S+?@(?:[^\s.]+\.)+[^\s.]{2,}$/s.test(v) ||
          'Dirección de correo no válida',
      ],
      dniRules: [
        (v: any) => /^([0-9])*$/.test(v) || 'Solo puede ingresar números',
        (v: any) => !!v || 'Identificación requerida',
      ],
      phoneRules: [(v: any) => !!v || 'Número de teléfono requerida'],
      nameRules: [(v: any) => !!v || 'Nombres requeridos'],
      lastnameRules: [(v: any) => !!v || 'Apellidos requeridos'],
      programaRules: [(v: any) => !!v || 'Campo necesario'],
      valid: false,
      visible: true,
      dni: this.value,
      nombres: '',
      apellidos: '',
      email: '',
      telefono: null,
      auxins: '',
      otro: false,
      programa: '',
      institucion: '',
    }
  },
  methods: {
    async submit(e: any) {
      e.preventDefault()

      if ((this as any).valid) {
        try {
          const result = await eventoService.Asistencia({
            id_evento: this.id_evento,
            participante: this.form,
          })

          if (result.ok) {
            Swal.fire(
              'Éxito',
              'Registro de asistencia exitoso',
              'success'
            ).then(() => {
              location.href = this.url_evento
            })
          }
        } catch (error) {
          Swal.fire(
            'Error',
            'ups!!, ha ocurrido un error, Usted ya registro asistencia anteriormente',
            'error'
          )
        }
      }
    },

    change(evt: any) {
      if (evt == 'Otra') {
        ;(this as any).otro = true
      } else {
        ;(this as any).otro = false
        ;(this as any).institucion = (this as any).auxins
      }
    },

    ocultar() {
      ;(this as any).visible = false
      this.$emit('visible', (this as any).visible)
    },
  },

  computed: {
    ...mapState('registro', ['instituciones']),
    form() {
      return {
        nombres: (this as any).nombres,
        apellidos: (this as any).apellidos,
        dni: (this as any).dni,
        email: (this as any).email,
        telefono: (this as any).telefono,
        programa: (this as any).programa,
        institucion: (this as any).institucion,
      }
    },
  },
})
